import apiClient from 'api/common/common'
import { Status } from 'api/common/statuses'
import { AxiosResponse } from 'axios'
import { PaymentAlertResponse } from 'api/common/responses'

/**
 * 入金アラート取得API
 * @param callback
 */
export const paymentAlertAPI = async (callback: (status: Status, result: PaymentAlertResponse) => void) => {
  await apiClient.get('/paymentAlert').then((response: AxiosResponse<PaymentAlertResponse>) => {
    const status = response?.headers['x-aqc-status'] ?? 'failed'
    callback(status, response.data)
  }).catch((error) => {
    console.error(error)
  })
}
